import React, {useState, useEffect} from 'react'
import * as style from './ContentFooter.module.css'
import { trackingEventCallAPI } from '../../../../api/trackingSDK'
import { EventTrackingList } from '../../../../api/const'
import {openAppZalo, openDeeplink} from '../../../CommonFunction'
import * as qs from "query-string";
import Util from "../../../../utils/utils";

const ContentFooter = ({ bindingInfo, sessionTracking }) => {
    const [redirecturl, setRedirecturl] = useState("")
    const [linkAppZaloPay, setLinkAppZaloPay] = useState("https://zalopay.vn/#tai-zalopay")

    useEffect(() => {
        let params = qs.parse(window.location.href.split('?')[1]);
        if (Object.entries(params).length !== 0 && params.constructor !== Object) {
            setRedirecturl(params.redirect_url);
        } else {
            openDeeplink(bindingInfo, params.redirect_url);
        }
        document.body.className = 'mobilehome';
        return () => {
            document.body.className = '';
        }
        // eslint-disable-next-line no-use-before-define
    }, []);

    useEffect(() => {
        if (Util.getMobileOS() === "Android") {
            setLinkAppZaloPay("https://play.google.com/store/apps/details?id=vn.com.vng.zalopay&hl=vi")
        } else if (Util.getMobileOS() === "iOS") {
            setLinkAppZaloPay("https://itunes.apple.com/vn/app/zalo-pay-thanh-toan-trong/id1112407590?mt=8")
        } else {
            setLinkAppZaloPay("https://zalopay.vn/#tai-zalopay")
        }
    }, [])

    const handleEventTrackingClickOpenApp = (eventName) => {
        const eventId = EventTrackingList.normalLandingPage.eventId[eventName];
        const metaData = {
            agent: navigator.userAgent,
            requestID: bindingInfo?.binding_token
        }
        trackingEventCallAPI(eventId, sessionTracking, metaData)
    }

    const openAppZaloPay = () => {
        openDeeplink(bindingInfo, redirecturl);
        handleEventTrackingClickOpenApp("clickButtonOpenAppZaloPay")
    }

    const openZPI = () => {
        openAppZalo(bindingInfo);
        handleEventTrackingClickOpenApp("clickButtonOpenAppZalo")
    }

    return (
        <footer id={style.footerMiddleAuthorizeBinding}>
            <button onClick={openZPI} type="button" className={`${style.zaloBtn}`}>
                Mở Zalo để liên kết
            </button>
            <p> Chưa có ứng dụng Zalo? <a href="https://zalo.me">Tải ngay</a></p>
            <button onClick={openAppZaloPay} type="button" className={`${style.zaloPayBtn}`}>
                Mở Zalopay để liên kết
            </button>
            <p> Chưa có ứng dụng Zalopay? <a href={linkAppZaloPay}>Tải ngay</a></p>
        </footer>
    )
}

export default ContentFooter;
